import styled from 'styled-components'

export const TextSpan = styled.div`
  color: rgb(20, 23, 26);
  font-size: 15px;
  padding-top: 2px;
  white-space: pre-wrap;
`
